import React, { useState, useRef } from "react";
import { Button } from "./Button";
import { ui } from "../constants";
import { map } from "lodash";
import { SetListItem } from "./SetListItem";
import { SetNameDialog } from "./SetNameDialog";
import styled from "@emotion/styled";
import { ViewTitle } from "./ViewTitle";
import { Add } from "@mui/icons-material";
import { useUser } from "./UserProvider";
import { useUserData } from "./UserDataProvider";
import { useSettings } from "./SettingsProvider";

const Main = styled.div`
  display: grid;
  height: 100%;
  width: 100%;
  grid-template-rows: auto minmax(0, auto) auto 1fr;
  grid-template-columns: minmax(0, 1fr);
`;

const NewSetButton = styled(Button)`
  margin-top: 10px;
  justify-self: end;
`;

const SetList = styled.div`
  overflow-y: auto;
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  // min-width: 0;
  min-height: 0;
`;

const DataWarning = styled.div`
  margin-top: 5px;
  margin-bottom: 3px;
  font-weight: 400;
`;

export const SetsView = () => {
  const { auth } = useUser();
  const isLoggedIn = auth.loggedIn;
  const {
    settings: { lang },
  } = useSettings();
  const { sets, activeSet, setFunctions } = useUserData();
  const [dialog, setDialog] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  const items = map(sets, (elems, setName) => (
    <SetListItem
      key={setName}
      setName={setName}
      selected={setName === activeSet}
    />
  ));

  return (
    <Main>
      <ViewTitle label={ui.labels.setsTitle[lang]} />
      {/* {items.length > 0 && ( */}
      {/* )} */}
      <SetList>
        {items}
      </SetList>
      <NewSetButton
        tooltip={ui.tooltips.newSet[lang]}
        icon={<Add />}
        iconPosition="left"
        onMouseDown={(event) => {
          setShowDialog(true);
          event.preventDefault();
        }}
      >
        {ui.labels.newSet[lang]}
      </NewSetButton>
      <div></div>
      <SetNameDialog
        show={showDialog}
        value={dialog}
        alreadyExists={Object.keys(sets).includes(dialog)}
        onCancel={() => {
          setDialog("");
          setShowDialog(false);
        }}
        onSave={() => {
          setFunctions.addToSet(dialog, []);
          setDialog("");
          setShowDialog(false);
        }}
        onChange={(value) => setDialog(value)}
      />
    </Main>
  );
};
